import React, { useEffect, useState } from 'react';
import "./HotelGuidelines.css";
import Header from "../components/Header";
// import img from "../../assets/HotelGuide/hotelGuide.jpg";
// import floor from "../../assets/HotelGuide/floorPlan.png";
import { useLocation, useNavigate } from 'react-router-dom';
import useAuth from '../../customHooks/useAuth';
import axios from 'axios';
import { baseUrl } from '../../common/baseUrl';
import backImg from "../../assets/HotelGuide/hotelGuidelineback.png"
import locationIcon from "../../assets/icons/location.png"
import operatorIcon from "../../assets/icons/operator.png"
import guideIcon from "../../assets/icons/regulation.png"
import axiosInstance from '../../axiosInstance/axiosInstance';


export default function HotelGuidelines() {

  const location = useLocation();
  const navigate = useNavigate(); 

  const bookingId = location.state?.bookingId || "";
  const hotelId = location.state?.hotelId || "";
  const hotelAddress = location.state?.hotelAddress || "";
  const hotelName = location.state?.hotelName || '';
  const checkInDate = location.state?.checkInDate || "";
  const checkOutDate = location.state?.checkOutDate || "";
  const status = location.state?.status || "";
  const activeTab = location.state?.activeTab || "";
  const Data = location.state?.Data || "";
  const booking_code = location.state?.booking_code || "";
  

  const [photos,setPhotos]  = useState([]);
  const [loading,setLoading] = useState(false);

  const [floorImages,setFloorImages] = useState([]);
  const [floorLoading,setFloorLoading] = useState(false);

  const [modal,setModal] = useState(false);
  const [modalImg,setModalImg] = useState("");

  const closeModal = (index,type)=>{
    setModal(!modal);
    if(type==="photo"){
      setModalImg(photos[index]);
    }
    else{
      setModalImg(floorImages[index])
    }
  }


  useEffect(()=>{
    if(bookingId==="" || hotelId===""){
      navigate("/bookings");
    }
  },[bookingId,hotelId,navigate]);

  // For Refresh Handle
  useAuth();

  useEffect(()=>{

    const fetchPhotos = async()=>{
      const urls = [];
      for(let i=0;i<Data.photos.length;i++){
        try{
          setLoading(true);
          const response = await axiosInstance.get(`/api/v1/images/download-presigned-url?key=${Data.photos[i]}`);

          urls.push(response.data.url)
        
        }catch(error){
          urls.push(null);
          console.log(error);
        }
      }



      setPhotos(urls);
      setLoading(false);
    }

    // For Fetching Photos
    if(Data.photos){
      if(photos.length > 0){
        // console.log("Photos Loaded")
      }
      else{
        fetchPhotos();
      }
    }

    const fetchFloorImages = async()=>{
      const urls = [];
      for(let i=0;i<Data.floor_map.length;i++){
        try{
          setFloorLoading(true);
          const response = await axiosInstance.get(`/api/v1/images/download-presigned-url?key=${Data.floor_map[i]}`);

          urls.push(response.data.url)
        
        }catch(error){
          urls.push(null);
          console.log(error);
        }
      }
      setFloorImages(urls);
      setFloorLoading(false);


    }
  

    // For Fetching Floor Photos
    if(Data.floor_map){
      if(floorImages.length>0){
        // console.log("FLoor Images Loaded");
      }
      else{
        fetchFloorImages();
      }
    }
  },[])

  

  return (
    <div className='hotelGuidelines'>

      <Header title="Hotel Guidelines"
        hotelName = {hotelName}
        hotelAddress = {hotelAddress}
        checkInDate = {checkInDate}
        checkOutDate = {checkOutDate}
        status = {status}
        activeTab = {activeTab}
        hotelId = {hotelId}
        bookingId = {bookingId}
        movetoHotel = "movetoHotel"
        booking_code = {booking_code}
      />



      <div className='hotelGuidelines-details'>

  

        {/* Hotel Background Image and Details */}
        <div className = "hotel-background-pic" style={{backgroundImage: `url(${backImg})`}}>
          <div className='hotel-background-details'>
            <h2>
              {hotelName}  
            </h2>
           
            <div className='hotel-background-details-addr'>
              <img src={locationIcon} alt="Error" />
              <span>
              {/* {hotelAddress} */}
                Bangalore, Karnataka 4th Cross, Maytri Layout, Hope farm signal, Whitefield, Bengaluru, Postal Code : 560066
              </span>
            </div>
     
          </div>
        </div>

        <div className='hotelGuidelines-spacing'>
          {/* Contact Box */}
          {
            (Data?.contact || Data?.email) &&
            <>
              <div className='hotel-contact-details'>
                
                <img src={operatorIcon} alt="Error" />
                
                <div className='' style={{marginTop : "20px"}}>
                  <h4>
                    {
                      Data?.contact ? `+ ${Data.contact}` : ""
                    }
                  </h4>
                  <h4 style={{marginTop : "5px"}}>
                    {Data?.email || ""}
                  </h4>
                </div>
    
              </div>
            </>
          }
          {/* Guidelines */}
          {
            (Data?.guidelines) &&
              <>
                <div className='hotel-guide-details'>
                  
                  <img src={guideIcon} alt="Error" />
                  
                  <div className='' style={{marginTop : "20px"}}>
                    <h4>
                      Please follow the guidelines mentioned below :
                    </h4>
                    <ul>
                      {
                        Data.guidelines && 

                        Data.guidelines.map((guideline,index)=>(
                          <li key={index}>{guideline}</li>
                        ))
                      }
                  
                    </ul>
                  </div>
      
                </div>
              </>
          }


          
          {/* Hotel Photos Details */}
          {
            Data.photos && (
              <>
                <h2>Hotel Photos</h2>
                <div className="hotelGuide-photos">
                  {loading ? (
                    Data.photos.map((photo, index) => (
                      <div className="skeleton" key={index}></div>
                    ))
                  ) : (
                    photos.map((photo, index) => (
                      <div className="hotelGuide-photo" key={index}>
                        <img
                          src={photo}
                          alt="Error"
                          onClick={() => closeModal(index, "photo")}
                        />
                      </div>
                    ))
                  )}
                </div>
              </>
            )
          }


          {/* Floor Plan  */}
          <div className="hotelGuide-plan">
            {Data.floor_map && Data.floor_map.length > 0 && (
              <>
                <h2>Floor Plan</h2>
                <div className="floor-img-list">
                  {floorLoading ? (
                    Data.floor_map.map((_, index) => (
                      <div className="skeleton" key={index}></div>
                    ))
                  ) : (
                    floorImages.map((photo, index) => (
                      <div className="floor-img" key={index}>
                        <img
                          src={photo}
                          alt={`Floor Plan ${index + 1}`}
                          onClick={() => closeModal(index, "floor")}
                        />
                      </div>
                    ))
                  )}
                </div>
              </>
            )}
          </div>
 

        </div>

      </div>


      {/* Modals */}
      {
        modal &&

        <div className="modal" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}C>
            <div className="modal-image">
              <img src={modalImg} alt="Error"/>
            </div>
          </div>

        </div>
      }
      
    </div>
  )
}
